import { classes } from 'html-classes';

import { company } from '~/company/Company';
import { ProductCardSkeletonProps } from '~/components/ProductCardV3/skeletons/types';

import styles from './ProductCardSkeletonC.module.scss';

/**
 * ProductCardSkeletonC - Loading skeleton for ProductCardC
 * Matches exact dimensions and layout of ProductCardC (full width × 118px mobile, 160px web)
 */
const ProductCardSkeletonC = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div
      className={classes([styles.skeleton, className])}
      data-company={company.name}
    >
      <div className={styles.imageContainer}>
        <div className={styles.imageSkeleton} />
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.infoSection}>
          <div className={styles.nameLine} />
          <div className={styles.unitPriceLine} />
        </div>

        <div className={styles.badgesRow}>
          <div className={styles.badgeSkeleton} />
          <div className={styles.badgeSkeleton} />
          <div className={styles.badgeSkeleton} />
        </div>

        <div className={styles.bottomRow}>
          <div className={styles.priceSection}>
            <div className={styles.priceLine} />
          </div>
          <div className={styles.counterWrapper}>
            <div className={styles.counterButtonMinus} />
            <div className={styles.counterButtonPlus} />
            <div className={styles.counterColumn}>
              <div className={styles.counterButton} />
              <div className={styles.counterPriceLine} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeletonC;
